export default {
      id: "assessment-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#assessment",
      toString: function () {
        return this.url;
      }
    }